<template>
    <v-dialog v-model="historyDialog" width="1600" scrollable>
        <template v-slot:activator="{ on, attrs }">
            <span style="justify-content: space-around; display: flex; margin-top: -3px;">
                <v-tooltip content-class="pa-0" left max-width="70%">
                    <template v-slot:activator="tooltip">
                        <v-btn
                            icon
                            small
                            v-on="tooltip.on"
                        >
                        <v-icon
                            color="grey"
                            small
                            :disabled="historyPreview.length <= 0 || !entityId"
                            v-bind="attrs"
                            v-on="on"
                        >
                            mdi-information
                        </v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-simple-table
                            class="text-size"
                            v-if="entityId && historyPreview.length > 0"
                            fixed-header
                            height="100%"
                            style="width: 100%; max-width: 100%;"
                        >
                            <thead>
                                <tr>
                                    <th class="text-size" scope="col">
                                        {{ $t("Modified by") }}
                                    </th>
                                    <th class="text-size" scope="col">
                                        {{ $t("Date") }}
                                    </th>
                                    <th class="text-size" scope="col">
                                        {{ $t("Name") }}
                                    </th>
                                    <th class="text-size" scope="col">
                                        {{ $t("From") }}
                                    </th>
                                    <th class="text-size" scope="col">
                                        {{ $t("To") }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(entry, index) in historyPreview">
                                    <tr
                                        :key="'previewEntry-' + index"
                                    >
                                        <td class="text-size">{{ entry.updated_by }}</td>
                                        <td class="text-size">{{ entry.updated_at }}</td>
                                        <td v-if="parseChangeType(entry) === 'created'" class="text-size" colspan="3">{{$t('Entry created')}}</td>
                                        <td v-if="parseChangeType(entry) === 'deleted'" class="text-size" colspan="3">{{$t('Entry deleted')}}</td>
                                        <td v-if="parseChangeType(entry) === 'updated'" class="text-size">{{ parseAttribute(entry.attribute) }}</td>
                                        <td v-if="parseChangeType(entry) === 'updated'" class="text-size">{{ entry.from }}</td>
                                        <td v-if="parseChangeType(entry) === 'updated'" class="text-size">{{ entry.to }}</td>                                    </tr>
                                </template>
                            </tbody>
                        </v-simple-table>
                        <span v-else class="d-block pa-3 text-size">
                            {{ $t("No data available") }}
                        </span>
                    </v-card>
                </v-tooltip>
            </span>
        </template>
        <v-card height="720" width="100%">
            <v-card-title>
                <v-row no-gutters>
                    <v-col cols="auto">
                        {{ $t("History") }}
                    </v-col>
                    <v-spacer />

                    <v-col cols="auto">
                        <v-btn
                            class="text-size"
                            text
                            color="primary"
                            @click="historyDialog = false"
                        >
                            {{ $t("Close") }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-card-text @scroll="onScroll">
                <v-row>
                    <v-simple-table
                        fixed-header
                        height="100%"
                        style="width: 100%"
                    >
                        <thead>
                            <tr>
                                <th class="text-size" scope="col">
                                    {{ $t("Modified by") }}
                                </th>
                                <th class="text-size" scope="col">
                                    {{ $t("Date") }}
                                </th>
                                <th class="text-size" scope="col">
                                    {{ $t("Name") }}
                                </th>
                                <th class="text-size" scope="col">
                                    {{ $t("From") }}
                                </th>
                                <th class="text-size" scope="col">
                                    {{ $t("To") }}
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="history.length > 0">
                            <template v-for="(entry, index) in history">
                                <tr
                                    :key="'entry-' + index"
                                >
                                    <td class="text-size">{{ entry.updated_by }}</td>
                                    <td class="text-size">{{ entry.updated_at }}</td>
                                    <td v-if="parseChangeType(entry) === 'created'" class="text-size" colspan="3">{{$t('Entry created')}}</td>
                                    <td v-if="parseChangeType(entry) === 'deleted'" class="text-size" colspan="3">{{$t('Entry deleted')}}</td>
                                    <td v-if="parseChangeType(entry) === 'updated'" class="text-size">{{ parseAttribute(entry.attribute) }}</td>
                                    <td v-if="parseChangeType(entry) === 'updated'" class="text-size">{{ entry.from }}</td>
                                    <td v-if="parseChangeType(entry) === 'updated'" class="text-size">{{ entry.to }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </v-simple-table>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import {startCase} from 'lodash';

export default {
    name: "History",
    props: {
        entityType: {
            type: String,
            default: 'dependency'
        },
        entityId: {
            type: Number,
            default: undefined
        },
        historyPreview: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            historyDialog: false,
            history: [],
            showAmount: 100
        };
    },

    watch: {
        historyDialog(newValue) {
            if (newValue && !this.history.length) {
                this.fetchData();
            }
        }
    },

    methods: {
        fetchData() {
            let url = 'cedexSettings/loadHistory';
            return axios.get(url, {
                params: {
                    id:   this.entityId,
                    type: this.entityType
                }
            }).then(response => {
                if (
                    response.data.data
                    && response.data.data.length === 0
                ) {
                    this.history = [];
                } else {
                    this.history = response.data.data;
                    if (!this.history) {
                        this.history = [];
                    }
                }
            });
        },

        onScroll ({ target: { scrollTop, clientHeight, scrollHeight }})
        {
            if (scrollTop + clientHeight + 150 >= scrollHeight) {
                this.showAmount += 100;
            }
        },

        parseAttribute(attribute)
        {
            let replacements = {
                Iso: 'ISO',
                Sts: 'STS',
            }
            let replacedString = attribute;
            for (let key in replacements) {
                replacedString = startCase(replacedString).replace(key, replacements[key]);
            }
            return replacedString;
        },

        parseChangeType(entry)
        {
            let changeType = entry.change_type;
            if (typeof changeType === 'undefined') {
                changeType = entry.attribute;
                if (
                    changeType !== 'created'
                    && changeType !== 'deleted'
                ) {
                    changeType = 'updated';
                }
            }
            return changeType;
        }
    }
};
</script>

<style scoped>
.text-size {
    font-size: 12px !important;

    max-width: 20vw;
    word-wrap: break-word;
}
.compact-form {
    transform: scale(0.75) translateY(-6px);
    transform-origin: left;
}

.selectedSpareParts >>> tr:not(:first-child) > td {
    border-top: 5px solid white;
}

.selectedSpareParts >>> tr.work-order:not(:first-child) > td {
    border-top: 0;
}

.historyList {
    list-style-type: none;
}

.ui-terminal {
    /* margin-top: 5px; */
    height: 22em;

    border: 1px;
    overflow-y: scroll;
    border-style: solid;
    max-width: 40em;
    background-color: black;
    white-space: pre-wrap;
}
</style>
